<template>
    <quill-editor
      class="picture-text-details"
      v-model="curValue"
      ref="myQuillEditor"
      :options="editorOption">
    </quill-editor>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor, Quill} from 'vue-quill-editor'
import {ImageExtend, QuillWatch} from 'quill-image-extend-module'
import Lockr from 'lockr'
Quill.register('modules/ImageExtend', ImageExtend)
export default {
  name: 'editor',
  props: ['action', 'value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      curValue: this.value,
      // 富文本框参数设置
      editorOption: {
        placeholder: '',
        theme: 'snow', // or 'bubble'
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'font': [] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image']
            ],
            handlers: {
              'image': function () {
                QuillWatch.emit(this.quill.id)
              }
            }
          },
          ImageExtend: {
            loading: true,
            name: 'file_upload',
            action: this.action,
            accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
            sizeError: () => {}, // 图片超过大小的回调
            start: () => {}, // 可选参数 自定义开始上传触发事件
            end: (res) => {
              console.log('end', res)
            }, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            error: () => {
              alert('上传失败')
            }, // 可选参数 上传失败触发的事件
            success: () => {}, // 可选参数  上传成功触发的事件
            response: (res) => {
              if (res.code == 0) {
                // 获取文件扩展名
                let filePath = res.data.filename
                let index = filePath.lastIndexOf('.')
                let ext = filePath.substr(index + 1)
                // 判断是否为图片
                if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp'].indexOf(ext.toLowerCase()) !== -1) {
                  return res.data.path
                } else {
                  alert('文件格式错误')
                }
              }
              return false
            }
          }
        }
      }
    }
  },
  components: {quillEditor},
  watch: {
    value: function (val) {
      this.curValue = val
    },
    curValue: function (val) {
      this.curValue = this.curValue.replace('<img>', '')
      this.curValue = this.curValue.replace('<span style="color: red;">[uploading100%]</span>', '')
      this.$emit('change', this.curValue)
    }
  },
  methods: {
  },
  mounted() {
  },
  created() {
  }
}
</script>

<style scoped>
</style>
